"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OneOfPropertyModel = exports.OneOfArrayModel = exports.DependenciesModel = void 0;
const schema_object_1 = require("../schema_object");
const schema_properties_1 = require("../schema_properties");
const conditions_1 = require("./conditions");
class DependenciesModel extends schema_object_1.SchemaObject {
    addConstCondition(edge, dependentFields) {
        var _a;
        const key = edge.dependentOn.uniqueKey();
        const values = edge.values;
        const requiredFieldKeys = dependentFields
            .filter((field) => field.isRequired)
            .map((field) => field.uniqueKey());
        (_a = this[key]) !== null && _a !== void 0 ? _a : (this[key] = new OneOfArrayModel());
        const oneOfArray = this[key];
        // remove any existing properties with the same condition
        let edgeCondition = edge.condition();
        edgeCondition = edgeCondition.const;
        oneOfArray.oneOf = oneOfArray.oneOf.filter((oneOfPropertyModel) => {
            const existingCondition = oneOfPropertyModel.properties.get(key);
            return existingCondition.const !== edgeCondition;
        });
        const newPropertyModel = new OneOfPropertyModel(edge.condition(), key, requiredFieldKeys);
        newPropertyModel.properties.addFields(dependentFields);
        oneOfArray.oneOf.push(newPropertyModel);
        // add all other values as properties
        if (oneOfArray.oneOf.length && values.length) {
            const existingConditions = oneOfArray.oneOf
                .map((oneOfPropertyModel) => oneOfPropertyModel.properties.get(key))
                .map((condition) => condition.const);
            const missingValues = values.filter((value) => !existingConditions.includes(value));
            missingValues.forEach((value) => {
                const condition = new conditions_1.ConstCondition(value);
                oneOfArray.oneOf.push(new OneOfPropertyModel(condition, key, []));
            });
        }
    }
    addRequiredCondition(edge) {
        var _a;
        const key = edge.dependentOn.uniqueKey();
        const propertyModel = new OneOfPropertyModel(edge.condition(), key, edge.requiredFields);
        (_a = this[key]) !== null && _a !== void 0 ? _a : (this[key] = new OneOfArrayModel());
        this[key].oneOf.push(propertyModel);
    }
    get(key) {
        return this[key];
    }
}
exports.DependenciesModel = DependenciesModel;
class OneOfArrayModel {
    constructor() {
        this.oneOf = [];
    }
}
exports.OneOfArrayModel = OneOfArrayModel;
class OneOfPropertyModel {
    constructor(condition, key, required) {
        this.properties = new schema_properties_1.SchemaProperties();
        this.properties[key] = condition;
        if (required.length > 0) {
            this.required = required;
        }
    }
}
exports.OneOfPropertyModel = OneOfPropertyModel;
